module.exports = {
  id: 4,
  name: 'Fast Feet',
  categories: ['cardio', 'coordination', 'legs'],
  sports: [
    'baseball',
    'basketball',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Coordination',
  points: 15,
  instructions:
    'Fast feet time! Stand with feet apart and run in place as fast as you can! This makes you super fast! Ready to try it?',
  timedInstructions: [
    {
      time: 0,
      text: "Let's do fast feet! Stand with feet apart!",
    },
    {
      time: 2,
      text: 'Get ready to run in place!',
    },
    {
      time: 4,
      text: 'Keep your knees up high!',
    },
    {
      time: 6,
      text: 'Ready to become lightning fast! 3, 2, 1, START!',
    },
    // SET 1
    {
      time: 9,
      text: 'Run fast in place, 1!',
    },
    {
      time: 11,
      text: 'Keep your knees up high!',
    },
    {
      time: 13,
      text: 'Run fast in place, 2!',
    },
    {
      time: 15,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 17,
      text: 'Run fast in place, 3!',
    },
    {
      time: 19,
      text: 'Keep your arms pumping!',
    },
    {
      time: 21,
      text: 'Run fast in place, 4!',
    },
    {
      time: 23,
      text: 'Lightning speed!',
    },
    {
      time: 25,
      text: 'Run fast in place, 5!',
    },
    {
      time: 27,
      text: 'Keep your knees up high!',
    },
    {
      time: 29,
      text: 'Run fast in place, 6!',
    },
    {
      time: 31,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 33,
      text: 'Run fast in place, 7!',
    },
    {
      time: 35,
      text: 'Keep your arms pumping!',
    },
    {
      time: 37,
      text: 'Run fast in place, 8!',
    },
    {
      time: 39,
      text: 'Lightning speed!',
    },
    {
      time: 41,
      text: 'Run fast in place, 9!',
    },
    {
      time: 43,
      text: 'Keep your knees up high!',
    },
    {
      time: 45,
      text: 'Run fast in place, 10!',
    },
    {
      time: 47,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 49,
      text: 'Run fast in place, 11!',
    },
    {
      time: 51,
      text: 'Keep your arms pumping!',
    },
    {
      time: 53,
      text: 'Run fast in place, 12!',
    },
    {
      time: 55,
      text: 'Lightning speed!',
    },
    {
      time: 57,
      text: 'Run fast in place, 13!',
    },
    {
      time: 59,
      text: 'Keep your knees up high!',
    },
    {
      time: 61,
      text: 'Run fast in place, 14!',
    },
    {
      time: 63,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 65,
      text: 'Run fast in place, 15!',
    },
    {
      time: 67,
      text: 'Great job! Take a break',
    },
    {
      time: 70,
      text: 'Breathe in and out',
    },
    {
      time: 73,
      text: 'You just did 15 fast feet reps!',
    },
    {
      time: 76,
      text: 'Your speed is incredible!',
    },
    {
      time: 79,
      text: 'Keep breathing, you got this!',
    },
    {
      time: 82,
      text: 'Your legs are getting stronger!',
    },
    {
      time: 85,
      text: 'Ready for round two!',
    },
    {
      time: 88,
      text: '3, 2, 1, KEEP GOING!',
    },
    // SET 2
    {
      time: 91,
      text: 'Run fast in place, 1!',
    },
    {
      time: 93,
      text: 'Keep your knees up high!',
    },
    {
      time: 95,
      text: 'Run fast in place, 2!',
    },
    {
      time: 97,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 99,
      text: 'Run fast in place, 3!',
    },
    {
      time: 101,
      text: 'Keep your arms pumping!',
    },
    {
      time: 103,
      text: 'Run fast in place, 4!',
    },
    {
      time: 105,
      text: 'Lightning speed!',
    },
    {
      time: 107,
      text: 'Run fast in place, 5!',
    },
    {
      time: 109,
      text: 'Keep your knees up high!',
    },
    {
      time: 111,
      text: 'Run fast in place, 6!',
    },
    {
      time: 113,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 115,
      text: 'Run fast in place, 7!',
    },
    {
      time: 117,
      text: 'Keep your arms pumping!',
    },
    {
      time: 119,
      text: 'Run fast in place, 8!',
    },
    {
      time: 121,
      text: 'Lightning speed!',
    },
    {
      time: 123,
      text: 'Run fast in place, 9!',
    },
    {
      time: 125,
      text: 'Keep your knees up high!',
    },
    {
      time: 127,
      text: 'Run fast in place, 10!',
    },
    {
      time: 129,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 131,
      text: 'Run fast in place, 11!',
    },
    {
      time: 133,
      text: 'Keep your arms pumping!',
    },
    {
      time: 135,
      text: 'Run fast in place, 12!',
    },
    {
      time: 137,
      text: 'Lightning speed!',
    },
    {
      time: 139,
      text: 'Run fast in place, 13!',
    },
    {
      time: 141,
      text: 'Keep your knees up high!',
    },
    {
      time: 143,
      text: 'Run fast in place, 14!',
    },
    {
      time: 145,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 147,
      text: 'Run fast in place, 15!',
    },
    {
      time: 149,
      text: 'Amazing job! Take another break',
    },
    {
      time: 152,
      text: 'Breathe in and out',
    },
    {
      time: 155,
      text: 'You just did 30 fast feet reps total!',
    },
    {
      time: 158,
      text: 'Your speed is getting faster!',
    },
    {
      time: 161,
      text: "Keep breathing, you're doing great!",
    },
    {
      time: 164,
      text: "You're building incredible speed!",
    },
    {
      time: 167,
      text: 'Ready for round three!',
    },
    {
      time: 170,
      text: '3, 2, 1, KEEP GOING!',
    },
    // SET 3
    {
      time: 173,
      text: 'Run fast in place, 1!',
    },
    {
      time: 175,
      text: 'Keep your knees up high!',
    },
    {
      time: 177,
      text: 'Run fast in place, 2!',
    },
    {
      time: 179,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 181,
      text: 'Run fast in place, 3!',
    },
    {
      time: 183,
      text: 'Keep your arms pumping!',
    },
    {
      time: 185,
      text: 'Run fast in place, 4!',
    },
    {
      time: 187,
      text: 'Lightning speed!',
    },
    {
      time: 189,
      text: 'Run fast in place, 5!',
    },
    {
      time: 191,
      text: 'Keep your knees up high!',
    },
    {
      time: 193,
      text: 'Run fast in place, 6!',
    },
    {
      time: 195,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 197,
      text: 'Run fast in place, 7!',
    },
    {
      time: 199,
      text: 'Keep your arms pumping!',
    },
    {
      time: 201,
      text: 'Run fast in place, 8!',
    },
    {
      time: 203,
      text: 'Lightning speed!',
    },
    {
      time: 205,
      text: 'Run fast in place, 9!',
    },
    {
      time: 207,
      text: 'Keep your knees up high!',
    },
    {
      time: 209,
      text: 'Run fast in place, 10!',
    },
    {
      time: 211,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 213,
      text: 'Run fast in place, 11!',
    },
    {
      time: 215,
      text: 'Keep your arms pumping!',
    },
    {
      time: 217,
      text: 'Run fast in place, 12!',
    },
    {
      time: 219,
      text: 'Lightning speed!',
    },
    {
      time: 221,
      text: 'Run fast in place, 13!',
    },
    {
      time: 223,
      text: 'Keep your knees up high!',
    },
    {
      time: 225,
      text: 'Run fast in place, 14!',
    },
    {
      time: 227,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 229,
      text: 'Run fast in place, 15!',
    },
    {
      time: 231,
      text: 'Great job! Take a final break',
    },
    {
      time: 234,
      text: 'Breathe in and out',
    },
    {
      time: 237,
      text: 'You just did 45 fast feet reps total!',
    },
    {
      time: 240,
      text: "You're a speed warrior!",
    },
    {
      time: 243,
      text: 'Keep breathing, almost done!',
    },
    {
      time: 246,
      text: 'Your coordination is amazing!',
    },
    {
      time: 249,
      text: 'Ready for the final round!',
    },
    {
      time: 252,
      text: '3, 2, 1, FINAL PUSH!',
    },
    // SET 4
    {
      time: 255,
      text: 'Run fast in place, 1!',
    },
    {
      time: 257,
      text: 'Keep your knees up high!',
    },
    {
      time: 259,
      text: 'Run fast in place, 2!',
    },
    {
      time: 261,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 263,
      text: 'Run fast in place, 3!',
    },
    {
      time: 265,
      text: 'Keep your arms pumping!',
    },
    {
      time: 267,
      text: 'Run fast in place, 4!',
    },
    {
      time: 269,
      text: 'Lightning speed!',
    },
    {
      time: 271,
      text: 'Run fast in place, 5!',
    },
    {
      time: 273,
      text: 'Keep your knees up high!',
    },
    {
      time: 275,
      text: 'Run fast in place, 6!',
    },
    {
      time: 277,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 279,
      text: 'Run fast in place, 7!',
    },
    {
      time: 281,
      text: 'Keep your arms pumping!',
    },
    {
      time: 283,
      text: 'Run fast in place, 8!',
    },
    {
      time: 285,
      text: 'Lightning speed!',
    },
    {
      time: 287,
      text: 'Run fast in place, 9!',
    },
    {
      time: 289,
      text: 'Keep your knees up high!',
    },
    {
      time: 291,
      text: 'Run fast in place, 10!',
    },
    {
      time: 293,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 295,
      text: 'Run fast in place, 11!',
    },
    {
      time: 297,
      text: 'Keep your arms pumping!',
    },
    {
      time: 299,
      text: 'Run fast in place, 12!',
    },
    {
      time: 301,
      text: 'Lightning speed!',
    },
    {
      time: 303,
      text: 'Run fast in place, 13!',
    },
    {
      time: 305,
      text: 'Keep your knees up high!',
    },
    {
      time: 307,
      text: 'Run fast in place, 14!',
    },
    {
      time: 309,
      text: 'Quick feet, quick feet!',
    },
    {
      time: 311,
      text: 'Run fast in place, 15!',
    },
    {
      time: 313,
      text: 'You did it, speed champion!',
    },
    {
      time: 315,
      text: "Awesome job, you're lightning fast!",
    },
  ],
};
